import { useRequest } from 'ahooks'

export default function({ store, service, expanded, record, dataSource, onExpand }) {
  const res = useRequest(async () => {
    const result = await store.externals.api.get(service.replace(/:id/g, record.id))

    function change(data) {
      if(data.id == record.id) {
        data.children = result
      }

      else if(data.children) {
        data.children.forEach(e => change(e))
      }
    }

    dataSource.forEach(e => change(e))
  }, { manual: true })

  if(record.leaf == true) {
    return <div className='w-8 inline-block' />
  }

  if(res.loading) {
    return <div className='pl-2 w-8 inline-block text-blue-600' >
      <i className='fa fa-spinner animate-spin' />
    </div>
  }

  if(expanded) {
    return <div onClick={() => onExpand(record)} className='w-8 pl-2 inline-block cursor-pointer hover:text-blue-600'>
      <i className='fa fa-minus-square-o' />
    </div>
  }

  if(record.children?.length > 0) {
    return <div onClick={() => onExpand(record)} className='w-8 pl-2 inline-block cursor-pointer hover:text-blue-600'>
      <i className='fa fa-plus-square-o' />
    </div>
  }

  return <div onClick={() => res.runAsync().then(() => onExpand(record))} className='w-8 pl-2 inline-block cursor-pointer hover:text-blue-600'>
    <i className='fa fa-plus-square-o' />
  </div>
}
